import { render } from "./VideoControls.vue?vue&type=template&id=73bb107b"
import script from "./VideoControls.vue?vue&type=script&lang=js"
export * from "./VideoControls.vue?vue&type=script&lang=js"

import "./VideoControls.vue?vue&type=style&index=0&id=73bb107b&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__